import React from "react";
import { RoutesComponent } from "../routes";

export default function App() {
  return <RoutesComponent />;
}
